// extracted by mini-css-extract-plugin
export var orderDetails = "_u5-2";
export var orderImage = "_u5-1";
export var orderMeta = "_u5-3";
export var orderSummary = "_u5-0";
export var rightArrow = "_u5-4";